import { render, staticRenderFns } from "./PagingList.vue?vue&type=template&id=1bd23082&scoped=true&"
import script from "./PagingList.vue?vue&type=script&lang=js&"
export * from "./PagingList.vue?vue&type=script&lang=js&"
import style0 from "./PagingList.vue?vue&type=style&index=0&id=1bd23082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd23082",
  null
  
)

export default component.exports